import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

interface DistributionItem {
  label: string;
  value: number;
}

interface DistributionChartProps {
  title: string;
  description?: string;
  data: DistributionItem[];
  colorClasses?: string[];
}

export function DistributionChart({ 
  title, 
  description, 
  data,
  colorClasses = [
    'bg-blue-500',
    'bg-green-500',
    'bg-yellow-500',
    'bg-purple-500',
    'bg-red-500',
    'bg-indigo-500',
    'bg-pink-500',
    'bg-orange-500'
  ]
}: DistributionChartProps) {
  const total = data.reduce((sum, item) => sum + item.value, 0);
  
  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        {description && <CardDescription>{description}</CardDescription>}
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="h-4 w-full rounded-full overflow-hidden flex">
            {data.map((item, index) => {
              const width = (item.value / total) * 100;
              const colorClass = colorClasses[index % colorClasses.length];
              
              return (
                <div 
                  key={item.label}
                  className={`${colorClass} h-full`}
                  style={{ width: `${width}%` }}
                  title={`${item.label}: ${item.value}%`}
                />
              );
            })}
          </div>
          
          <div className="grid grid-cols-2 gap-4">
            {data.map((item, index) => {
              const percentage = ((item.value / total) * 100).toFixed(1);
              const colorClass = colorClasses[index % colorClasses.length];
              
              return (
                <div key={item.label} className="flex items-center gap-2">
                  <div className={`h-3 w-3 rounded-full ${colorClass}`} />
                  <div className="space-y-1">
                    <p className="text-sm font-medium leading-none">{item.label}</p>
                    <p className="text-xs text-muted-foreground">{percentage}%</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
